var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SurveyForm',{ref:"surveyForm",attrs:{"isEditPage":true},on:{"on-submit-edit":_vm.editSurvey}})}
var staticRenderFns = []

export { render, staticRenderFns }